import { Image } from "@tiptap/extension-image";

const ResizableImage = Image.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      width: {
        default: "200px",
        parseHTML: (element) => element.style.width || "200px",
        renderHTML: (attributes) => {
          return {
            style: `width: ${attributes.width}`,
            class: "my-custom-class",
          };
        },
      },
      height: {
        default: "130px",
        parseHTML: (element) => element.style.height || "130px",
        renderHTML: (attributes) => {
          return {
            style: `height: ${attributes.height}`,
            class: "my-custom-class",
          };
        },
      },
    };
  },

  addNodeView() {
    return ({ node }) => {
      const container = document.createElement("div");
      container.style.position = "relative";
      container.style.display = "inline-block";

      const dom = document.createElement("img");
      dom.setAttribute("src", node.attrs.src);
      dom.setAttribute("class", "tiptap-image");
      dom.style.width = node.attrs.width;
      dom.style.height = node.attrs.height;
      dom.style.display = "block";

      const resizeHandle = document.createElement("div");
      resizeHandle.style.position = "absolute";
      resizeHandle.style.bottom = "0";
      resizeHandle.style.right = "0";
      resizeHandle.style.width = "10px";
      resizeHandle.style.height = "10px";
      resizeHandle.style.background = "rgba(0, 0, 0, 0.5)";
      resizeHandle.style.cursor = "nwse-resize";

      container.appendChild(dom);
      container.appendChild(resizeHandle);

      const handleMouseDown = (event) => {
        event.preventDefault();
        const startX = event.pageX;
        const startY = event.pageY;
        const startWidth = parseInt(
          document.defaultView.getComputedStyle(dom).width,
          10
        );
        const startHeight = parseInt(
          document.defaultView.getComputedStyle(dom).height,
          10
        );

        const minWidth = 100;
        const minHeight = 65;
        const maxWidth = 300;
        const maxHeight = 180;

        const doDrag = (dragEvent) => {
          let newWidth = startWidth + dragEvent.pageX - startX;
          let newHeight = startHeight + dragEvent.pageY - startY;

          if (newWidth < minWidth) {
            newWidth = minWidth;
          }
          if (newHeight < minHeight) {
            newHeight = minHeight;
          }

          if (newWidth > maxWidth) {
            newWidth = maxWidth;
          }
          if (newHeight > maxHeight) {
            newHeight = maxHeight;
          }

          dom.style.width = `${newWidth}px`;
          dom.style.height = `${newHeight}px`;
        };

        const stopDrag = () => {
          document.documentElement.removeEventListener(
            "mousemove",
            doDrag,
            false
          );
          document.documentElement.removeEventListener(
            "mouseup",
            stopDrag,
            false
          );
        };

        document.documentElement.addEventListener("mousemove", doDrag, false);
        document.documentElement.addEventListener("mouseup", stopDrag, false);
      };

      resizeHandle.addEventListener("mousedown", handleMouseDown, false);

      return {
        dom: container,
        update: (updatedNode) => {
          if (updatedNode.type.name !== this.name) {
            return false;
          }
          dom.style.width = updatedNode.attrs.width;
          dom.style.height = updatedNode.attrs.height;
          return true;
        },
      };
    };
  },
});

export { ResizableImage };
